var ASCII_HYPHEN_RANGE_RE, parseChangeScoreRange;

ASCII_HYPHEN_RANGE_RE = /^([+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?)\s*-\s*([+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?)$/;

parseChangeScoreRange = function(value) {
  var end, endStr, match, parts, start, startStr, str;
  if (value == null) {
    return null;
  }
  str = String(value).trim();
  if (!str) {
    return null;
  }
  if (str.indexOf('–') !== -1) {
    parts = str.split('–');
    if (parts.length !== 2) {
      return null;
    }
    startStr = parts[0].trim();
    endStr = parts[1].trim();
    if (!(startStr && endStr)) {
      return null;
    }
    start = Number(startStr);
    end = Number(endStr);
    if (_.isFinite(start) && _.isFinite(end)) {
      return [start, end];
    }
    return null;
  }
  match = str.match(ASCII_HYPHEN_RANGE_RE);
  if (match == null) {
    return null;
  }
  start = Number(match[1]);
  end = Number(match[2]);
  if (_.isFinite(start) && _.isFinite(end)) {
    return [start, end];
  }
  return null;
};

module.exports = {
  parseChangeScoreRange: parseChangeScoreRange
};
